/* global Swiper */

import setupSwiperAccessibility from '../../js/front/components/slider-swiper.js';

document.querySelectorAll( '.b-testimonial-slider-2' ).forEach( ( block ) => {

	const swiperContainer = block.querySelector( '.b-testimonial-slider-2__slider' );
	const slides = swiperContainer ? swiperContainer.querySelectorAll( '.swiper-slide' ) : [];

	if ( ! swiperContainer || slides.length === 0 ) {

		return;

	}

	const navPrev = block.querySelector( '.c-swiper-button--prev' );
	const navNext = block.querySelector( '.c-swiper-button--next' );
	const pagination = block.querySelector( '.swiper-pagination' );

	if ( slides.length <= 1 ) {

		block.classList.add( 'b-testimonial-slider-2--single-item' );

		if ( navNext ) {

			navNext.style.display = 'none';

		}
		if ( navPrev ) {

			navPrev.style.display = 'none';

		}
		if ( pagination ) {

			pagination.style.display = 'none';

		}

		return;

	}

	block.classList.remove( 'b-testimonial-slider-2--single-item' );



	const swiperInstance = new Swiper( swiperContainer, {
		direction: 'horizontal',
		spaceBetween: 24,
		slidesPerView: 1,
		slidesPerGroup: 1,
		watchOverflow: true,
		grabCursor: true,
		loop: slides.length > 2,
		keyboard: {
			enabled: true,
		},
		pagination: {
			el: pagination,
			clickable: true,
		},
		navigation: {
			nextEl: navNext,
			prevEl: navPrev,
		},
		breakpoints: {
			1024: {
				slidesPerView: 2,
			},
		},
		a11y: {
			enabled: true,
			prevSlideMessage: 'Poprzedni slajd',
			nextSlideMessage: 'Następny slajd',
			paginationBulletMessage: 'Idź do slajdu {{index}}',
			firstSlideMessage: '',
			lastSlideMessage: '',
			scrollOnFocus: false,
		},
	} );

	setupSwiperAccessibility( swiperInstance );

} );
